<template lang="html">

  <div class="cover-popup row-center" v-if="mostrar">
    <div class="popup xs">

      <p>Los próximos días 3 y 4 de agosto este portal permanecerá cerrado por labores de mantenimiento. Disculpa las molestias.</p>

      <div class="contenedor-botones">

        <a class="btn -solid-primary" @click="aceptar">Aceptar</a>

      </div>

    </div>
  </div>

</template>

<script lang="js">

  // Clave que marca que el usuario ya ha visto el aviso de mantenimiento (sin caducidad)
  // IMPORTANTE: Cambiar el nombre de la clave cuando se cambie el contenido del popup
  const STORAGE_KEY = 'aviso_mantenimiento_agosto';

  export default {
    name: 'popup-mantenimiento',
    data() {
      return {
        // Solo se muestra si la clave no existe previamente en el navegador
        mostrar: !window.localStorage.getItem(STORAGE_KEY)
      }
    },
    methods: {
      aceptar() {
        window.localStorage.setItem(STORAGE_KEY, 'true');
        this.mostrar = false;
      }
    }
  }
</script>

<style scoped lang="scss">

  .contenedor-botones {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/parts/popup-mantenimiento.vue